module.exports = __webpack_public_path__ + "img/LsgAudio28-31.9aab7621.jpeg";